/**
 * Ryan O'Dowd
 * 2024-11-21
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useEffect,
  useState,
} from 'react';
import TextInput from '@components/common/TextInput';
import getStyles from './styles';
import hooks from '@hooks';
import {
  updateGoalSettings,
} from '@utils/store/actions';

const CustomGoalInput = (props: CustomGoalInputProps) => {
  const dispatch = hooks.useTypedDispatch();
  const styles = hooks.useStyles(getStyles);

  const dailyGoalValue = hooks.useTypedSelector((state) => state.goalSettings[props.dailyGoalKey]);
  const [_textValue, setTextValue] = useState(`${dailyGoalValue}`);

  useEffect(() => {
    setTextValue(`${dailyGoalValue}`);
  }, [dailyGoalValue]);

  return (
    <TextInput
      style={styles.container}
      textColor={styles.colors.dialogText}
      contentStyle={styles.contentStyle}
      underlineColor='#00000000'
      activeUnderlineColor='#00000000'
      value={_textValue}
      onChangeText={(text) => {
        const newValue = text.replace(/[^0-9]/g, '');
        dispatch(updateGoalSettings({[props.dailyGoalKey]: +newValue}));
        setTextValue(newValue);
      }}
      keyboardType='number-pad'
    />
  );
};

class CustomGoalInputProps {
  dailyGoalKey: 'dailyPeanuts' | 'dailyLessons' | 'dailyVersesLeveledUp';
};

export default CustomGoalInput;
